// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconError: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
            <path
                fill="#E4104E"
                d="M21,30 C25.9717742,30 30,25.9717742 30,21 C30,16.0282258 25.9717742,12 21,12 C16.0282258,12 12,16.0282258 12,21 C12,25.9717742 16.0282258,30 21,30 Z M23.358871,25.412889 L21,23.0322581 L18.6375142,25.412889 C18.4669426,25.5834607 18.1911149,25.5834607 18.0205787,25.412889 L16.587111,23.9758065 C16.4165393,23.8052348 16.4165393,23.5294426 16.587111,23.358871 L18.9677419,21 L16.587111,18.6375142 C16.4165393,18.4669426 16.4165393,18.1911149 16.587111,18.0205787 L18.0241935,16.5834607 C18.1947652,16.412889 18.4705574,16.412889 18.641129,16.5834607 L21,18.9677419 L23.3624858,16.587111 C23.5330574,16.4165393 23.8088851,16.4165393 23.9794213,16.587111 L25.4165393,18.0241935 C25.587111,18.1947652 25.587111,18.4705574 25.4165393,18.641129 L23.0322581,21 L25.412889,23.3624858 C25.5834607,23.5330574 25.5834607,23.8088851 25.412889,23.9794213 L23.9758065,25.412889 C23.8052348,25.5834607 23.5294426,25.5834607 23.358871,25.412889 Z"
                transform="translate(-12 -12)"
            />
        </svg>
    );
};

export default React.memo(IconError);
